/**
 * Terms for container types used on the platform
 */

export const containerTypeTerms: Record<string, string> = {
  '22G0': 'container_type-22GP',
  '42G0': 'container_type-42GP',
  '45G0': 'container_type-45GP',
}
